import { Box } from "grommet";
import { Trophy } from "grommet-icons";
import { forwardRef, useMemo } from "react";
import { animated, useSpring } from "react-spring";
import User from "../types/User";
import { rankItemTheme } from "./rankItemTheme";
import RankNumber from "./RankNumber";
import "./style.css";

type Props = {
  users: User[];
  user: User;
};
const UserRankListingItem = forwardRef<any, Props>((props: Props, ref: any) => {
  const { user, users } = props;
  //const [tips, setTips] = useState(user.tips);
  const { val } = useSpring({
    val: user.currentTips,
    from: { val: 0 },
    config: {
      mass: 20,
      friction: 40,
      tension: 20,
    },
  });

  const { gradientVal } = useSpring({
    gradientVal: 100,
    from: { gradientVal: 0 },
    config: {
      mass: 20,
      friction: 0,
      tension: 20,
    },
  });

  let placement = 0;
  users.forEach((u, index) => {
    if (u.username === user.username) {
      placement = index + 1;
    }
  });

  let color = "purple";
  let backgroundColor = "#eddcff";
  let trophy;
  if (placement === 1) {
    backgroundColor = "transparent";
    trophy = (
      <Box animation={"pulse"} margin={{ start: "small" }}>
        <Trophy color={color} />
      </Box>
    );
  }

  const clamp = (num: number, min: number, max: number) =>
    Math.min(Math.max(num, min), max);

  const gradient = useMemo(() => {
    const theme = placement === 1 ? rankItemTheme : rankItemTheme;
    const { colorOne, colorTwo, colorThree } = theme;

    return `linear-gradient(-45deg, ${colorOne}, ${colorTwo}, ${colorThree})`;
  }, [placement]);

  return (
    <animated.div
      key={user.username + placement}
      ref={ref}
      style={{
        flexDirection: "row",
        background: gradient,
        backgroundSize: "600% 600%",
        WebkitAnimation: "Gradient 10s ease infinite",
        MozAnimation: "Gradient 10s ease infinite",
        animation: "Gradient 10s ease infinite",
        padding: 1,
        margin: 6,
        borderRadius: 8,
        fontFamily: "Orbitron",
        backgroundPosition: gradientVal.to((gradientVal) =>
          Math.floor(gradientVal)
        ),
      }}
    >
      <Box
        flex
        direction="row"
        margin={"xsmall"}
        style={{
          height: 20,
          borderRadius: 8,
          padding: 2,
          justifyContent: "space-between",
          color,
          backgroundColor,
          fontSize: 20,
        }}
      >
        <Box
          style={{ fontSize: 20, display: "flex" }}
          direction={"row"}
          justify={"center"}
          align={"center"}
        >
          <Box margin={{ end: "small" }}>
            <RankNumber number={placement} />
          </Box>
          <Box>{user.username}</Box>
          {trophy}
        </Box>
        <Box direction="row" align="center">
          <animated.div
            style={{
              fontSize: val.to(
                (val) =>
                  clamp(val / 100, 1, 4) * Math.sin(0.4 * val) +
                  clamp(Math.sqrt(val), 15, 35)
              ),
            }}
          >
            {val.to((val) => Math.floor(val))}
          </animated.div>
        </Box>
      </Box>
    </animated.div>
  );
});

export default UserRankListingItem;
